import React from 'react'
import Featured from '../../routes/Featured'
import 'regenerator-runtime/runtime'
import { DEFAULT_SUB_MENU, ROUTES } from '../../constants/navigation'
import { withHeaderOptions } from '../../hoc/withHeaderOptions'
import {
  addDisableOverscroll,
  addRouteType,
  addSecondaryMenu
} from '../../utils/navigation'
import Head from 'next/head'

const IndexPage = () => {
  return (
    <>
      <Head>
        <title>
          Interior Design Community | Share Home Interior Design Ideas With Our
          Design Community - DecorMatters
        </title>
        <meta
          name="description"
          content="Join our interior design community to get interior home ideas and share interior design inspiration. Our software for interior designers is ideal for realtors, gamers, and those who want to be a part of an exciting community where they can share their home interior design ideas."
        />
        <meta
          name="twitter:title"
          content="Interior Design Community | Share Home Interior Design Ideas With Our Design Community - DecorMatters"
        />
        <meta
          property="og:title"
          content="Interior Design Community | Share Home Interior Design Ideas With Our Design Community - DecorMatters"
        />
        <meta
          property="og:description"
          content="Join our interior design community to get interior home ideas and share interior design inspiration. Our software for interior designers is ideal for realtors, gamers, and those who want to be a part of an exciting community where they can share their home interior design ideas."
        />
        <meta property="og:site_name" content="DecorMatters" />
      </Head>
      <Featured />
    </>
  )
}

export default withHeaderOptions(IndexPage)(
  addSecondaryMenu(DEFAULT_SUB_MENU),
  addRouteType(ROUTES.COMMUNITY.FEATURED),
  addDisableOverscroll()
)

export async function getStaticProps() {
  return {
    props: {
      disableOverscroll: true
    }
  }
}
